import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getSliceFromNestedArrByKeys } from "core/iterable_utils";
import { getFirstProjectTreeSelected, getProjectTree, getProjectTreeSelected, setSelected, setTreeClicked } from "slices/project_work";
import { setReGetProtocol } from "slices/protocol";
import { getCurrentPage, setClickedTableRow, setCurrentEstmDocId, setCurrentEstmDocUrlPart } from "slices/ribbon";
import { changeSumEstmVisible } from "slices/summary_estimate";

const useTreeRow = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const selectedRows = useSelector(getProjectTreeSelected);
	const projectTree = useSelector(getProjectTree);
	const firstSelectedRow = useSelector(getFirstProjectTreeSelected);
	const currentPage = useSelector(getCurrentPage);

	const handleClick = ({ rowObj, event }) => {
		if (event?.ctrlKey) {
			if (selectedRows?.find((x) => x.key === rowObj?.key)) {
				dispatch(setSelected(selectedRows.filter((x) => x.key !== rowObj?.key)));
			} else {
				dispatch(setSelected([rowObj, ...selectedRows]));
			}
		} else if (event?.shiftKey) {
			event.preventDefault();
			let seekSlice = getSliceFromNestedArrByKeys({ arr: projectTree, startKey: firstSelectedRow.key, endKey: rowObj.key });
			if (seekSlice.length === 0) {
				seekSlice = getSliceFromNestedArrByKeys({ arr: projectTree, endKey: firstSelectedRow.key, startKey: rowObj.key });
			}
			dispatch(setSelected(seekSlice));
		} else if (event?.type === "contextmenu") {
			if (!selectedRows?.find((x) => x.key === rowObj?.key)) {
				dispatch(setSelected(rowObj));
				navigateToObj({ rowObj });
			}
		} else {
			dispatch(setSelected(rowObj));
			navigateToObj({ rowObj });
		}
	};

	const resetSettings = () => {
		localStorage.removeItem("displayScrollTop");
	};

	const navigateToObj = ({ rowObj }) => {
		let newUrl;
		let allowProtocolNavigate = true;

		if (rowObj.type === "summary") {
			const rowForScroll = document.querySelectorAll('tr[scrolltoid="' + rowObj.code + '"]');
			if (rowForScroll && rowForScroll.length > 0) {
				rowForScroll[0].scrollIntoView({
					block: "center",
					behavior: "smooth",
				});
			}
			newUrl = `/project/${rowObj.project_id}/`;
			dispatch(changeSumEstmVisible({ id: rowObj.id, val: true }));
		} else if (rowObj.type === "object" && rowObj.id !== 0) {
			newUrl = `/project/${rowObj.project_id}/osr/${rowObj.id}/`;
			dispatch(setCurrentEstmDocUrlPart("osr"));
			dispatch(setCurrentEstmDocId(rowObj.id));
		} else if (rowObj.type === "local") {
			newUrl = `/project/${rowObj.project_id}/lsr/${rowObj.id}/`;
			dispatch(setCurrentEstmDocUrlPart("lsr"));
			dispatch(setCurrentEstmDocId(rowObj.id));
			dispatch(setTreeClicked(rowObj));
		} else if (rowObj.type === "kats") {
			if (rowObj.id) {
				newUrl = `/project/${rowObj.project_id}/kats/${rowObj.id}/`;
				dispatch(setCurrentEstmDocId(rowObj.id));
			} else {
				newUrl = `/project/${rowObj.project_id}/kats/`;
				allowProtocolNavigate = false;
			}
			dispatch(setCurrentEstmDocUrlPart("kats"));
			dispatch(setTreeClicked(rowObj));
		} else if (rowObj.type === "vor") {
			allowProtocolNavigate = false;
			if (rowObj.id) {
				newUrl = `/project/${rowObj.project_id}/vor/${rowObj.id}/`;
				dispatch(setCurrentEstmDocId(rowObj.id));
			} else {
				newUrl = `/project/${rowObj.project_id}/vor/`;
			}
			dispatch(setCurrentEstmDocUrlPart("vor"));
		} else if (rowObj.type === "cost_summary") {
			allowProtocolNavigate = false;
			if (rowObj.id) {
				newUrl = `/project/${rowObj.project_id}/cost_summary/${rowObj.id}/`;
				dispatch(setCurrentEstmDocId(rowObj.id));
			} else {
				newUrl = `/project/${rowObj.project_id}/cost_summary/`;
			}
			dispatch(setCurrentEstmDocUrlPart("cost_summary"));
		}

		if (newUrl) {
			if (currentPage === "ProtocolViewer" && allowProtocolNavigate) {
				dispatch(setReGetProtocol(true));
				newUrl = `${newUrl}protocol/`;
			}
			resetSettings();
			navigate(newUrl);
			dispatch(setClickedTableRow(null));
		}
	};

	const getStyle = ({ rowObj }) => {
		const isSelected = selectedRows.find((x) => x.key === rowObj?.key) != null;

		const style = {};
		if (rowObj._has_comment) style.display = "flex";
		if (rowObj.double_is_winner === false) style.color = "#cccccc";

		if (isSelected === true && !rowObj.bgColor) {
			style.backgroundColor = "var(--tree-row-selected)";
		} else if (isSelected !== true && rowObj.bgColor) {
			style.backgroundColor = rowObj.bgColor;
		} else if (isSelected === true && rowObj.bgColor) {
			style.backgroundColor = `color-mix(in hsl, ${rowObj.bgColor} 90%, black 10%)`;
		}

		return style;
	};

	return { handleClick, getStyle };
};

export default useTreeRow;
